/*******************************************************************************
 * Copyright (c) 2019 Belltane
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *   
 *******************************************************************************/

import React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
 
import { makeStyles } from 'tss-react/mui';

import Container from '@mui/material/Container';
import PageSubHeader from '../Layout/PageSubHeader' 
import { useTranslation } from 'react-i18next';

const ContactUS = ( ) => {
    const { classes } = useStyles();
  const { t } = useTranslation()
    return (
        <>
            <PageSubHeader location={t('titles:contactus')} />
            <Grid container spacing={4} className={classes.pageContainer}>
                <Grid item xs={12} sm={12} md={12}>
                    <Container className={classes.cardGrid} maxWidth="xl">
                        <Grid container maxwidth="sm" justify="center" className={classes.pageContainer} spacing={5} alignItems="stretch" >
                            <Grid item xs={12} sm={6} md={6}>
                                <Typography style={{ color: "#383e56", textTransform: "uppercase" }} variant="h2" align="center" color="textPrimary" gutterBottom>
                                    {t('titles:contactus')}
                                </Typography>
                                <div className={classes.sectionTitleBorder}></div>
                                <Typography variant="h3" align="center" style={{ lineHeight: '2' }}>
                                    <span style={{ color: 'rgb(102 102 102)' }}> {t('descp:contactusEmail')}  : </span> info@belltane.com
                                </Typography>
                                <Typography variant="h4" align='center'  style={{marginTop:'30px'}}>
                                {t('descp:contactusDescp')}
                                    
                                </Typography>
                                <Button variant='contained' href="mailto:info@belltane.com" className='AlignCenter' style={{marginTop:'30px'}}>Contact Us</Button>
                            </Grid>
                            <Grid item xs={12} sm={6} md={6}>
                                <img src="/assets/images/bg/contact.png" alt="buisness" style={{ maxWidth: '300px' }} />
                            </Grid>
                        </Grid>
                    </Container>
                </Grid>
            </Grid>
        </>
    );
}
const useStyles = makeStyles({ "name": { ContactUS } })((theme) => ({

    pageContainer: {
        padding: '1.5%',
    },
    card: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    sectionTitleBorder: {
        width: '100px',
        height: '2px',
        marginRight: 'auto',
        marginLeft: 'auto',
        backgroundColor: '#fb743e',
        marginBottom: '30px',
    },
    title: {
        paddingTop: '20px'
    }
}));

export default  ContactUS;

